export const mobileSessionStorage = sessionStorage.getItem('mobile') === 'true';
export const setMobileSessionStorage = (value) => sessionStorage.setItem('mobile', value)